import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col, Checkbox, Popover, Icon, Table} from 'antd';
import '../resourcePool.css'
import {formatDate} from "../../../../../utils";

export default class Audio extends Component {
    static defaultProps = {checked:false,
	title:'fdfdfdfdfdfdfdfdfdfssssssss',
	type:'list',
	img:'/cm-sites/pms/library/images/audio.png',
	createTime:'2020-12-22 16:10:11',
		IsChecked:()=>{

		},
		onClick: () => {

		},
	};

     static propTypes = {
		title:PropTypes.string.isRequired,//传入dom 结构
		img:PropTypes.string.isRequired,//传入图标
		type:PropTypes.string.isRequired,//small  middle, big ,list
		checked:PropTypes.bool,//是否选中
		onClick:PropTypes.func.isRequired,//双击函数
		IsChecked: PropTypes.func.isRequired,//选中的函数
	};

    constructor(props) {
        super(props);
        this.state = {
			hover:false
		}		
    }
    componentWillMount() {
    }
    componentDidMount() {
    }	
    handleEnter() {
       this.setState({ hover:true })
     }
     handleOut() {
       this.setState({ hover:false })
     }	
    render(){	

		// 鼠标点击划过  公共
		let backgroundColor;
		let isHover;
		if(this.props.checked){
			backgroundColor='rgba(0, 80, 179, 0.04)'
			isHover ='block'
		}else{
			backgroundColor='#ffffff' ;
			isHover ='none'
			if (this.state.hover) {
				backgroundColor='rgba(0, 80, 179, 0.04)';
				isHover ='block'
			} else {
				backgroundColor= 'white';
				isHover ='none'
			}
		}
		return(
			<div style={{cursor:'pointer',}}  >
				{this.renderFileCard(backgroundColor,isHover)}
			</div>)
		
		}
		//渲染小 中，大
		renderFileCard(backgroundColor,isHover){
			let width,height,picW,picH,fontsize;
			if(this.props.type==='small'){
				width=140;height=140;picW=56;picH=56
			}else if(this.props.type==='middle'){
				width=200;height=200;picW=100;picH=100;fontsize=18
			}else if(this.props.type==='big'){
				width=300;height=300;picW=150;picH=150;fontsize=25
			}
			return(
			<div style={{width:width,height:height,textAlign:'center',paddingTop:11,background:backgroundColor,borderRadius:'16px',margin:'9px 18px 0',float:'left',position: 'relative'}}
			 onMouseEnter={()=>this.handleEnter()}
			 onMouseLeave={()=>this.handleOut()}
			 >
				<div  onClick={()=>{
					this.props.doubleClick&&this.props.doubleClick()
				}}>
					<img src={this.props.img} style={{width:picW,height:picH,objectFit:'cover'}}/>
					<div title={this.props.title}   className={'twoText'} style ={{fontSize:fontsize,overflow: 'hidden',textOverflow:'ellipsis'}}>{this.props.title}</div>
					<div style ={{fontSize:fontsize,overflow: 'hidden',textOverflow:'ellipsis'}}>{this.props.createTime}</div>
				</div>

				<Checkbox  checked={this.props.checked} style={{display:isHover,position:'absolute',right:9,top:9}}  onChange={(e)=>{
					this.props.IsChecked&&this.props.IsChecked(e)
				}}></Checkbox>
			</div>

			)
		}
		

}